import React from 'react';
import styled from "styled-components";
import { IoMdClose } from "react-icons/io";
import { IoSendOutline } from "react-icons/io5";
import { useGlobalContext } from '../useContext';
import axios from "axios";


function ChatEntrancer({setShowEn}) {
  const { isChat, setIsChat, message, setMessage} = useGlobalContext();

  function hideEntrancer() {
    setShowEn(false);
    //setIsChat(true);
  }
  

  //create message
  const createMessage = async () => {
    try {
      const response = await axios.post(
        "https://mihaela-diaconu.onrender.com/api/v1",
        {
          content: message,
        }
      );
      let messageCreated = response.data.message;
      if (messageCreated.content.charAt(0) === "9") {
        response.content.message = response.content.message.slice(1);
      }
    } catch (error) {
      console.log(error);
    }
  };

  const sendMessage = () => {
    createMessage();
    setMessage("");
    setIsChat(!isChat);
    setShowEn(false);
  };

  //button
  const handleKeyPress = (e) => {
    if (e.key === "Enter") {
      createMessage();
      setMessage("");
      setIsChat(!isChat);
      setShowEn(false);
    }
  };

  return (
    <Wrapper className={`chat__entrancer ${!isChat ? "chat__entrancer" : ""}`}>
      <div
        className="chat__entrance__header"
        onClick={() => hideEntrancer()}
      >
        <IoMdClose className="close__entrancer"></IoMdClose>
        <div className="image__message">
          <div className="img"><img src="assets/me.jpg" alt="me"></img></div>
        <p>Hey! If you have any questions, you can message me here. I'm usually
          online & will get back to you.</p>
        </div>
      </div>

      <div className="chat__entrancer__content">
        <div>
          <input
            type="text"
            placeholder="Reply..."
            value={message}
            onChange={(e) => setMessage(e.target.value)}
            onKeyPress={handleKeyPress}
          ></input>
          <button type="submit" onClick={() => sendMessage()}>
            <IoSendOutline></IoSendOutline>
          </button>
        </div>
      </div>
    </Wrapper>
  );
}

const Wrapper = styled.section`
  width: 300px;
  height: 12rem;
  background: black;
  position: fixed;
  z-index: 3000;
  right: -200px;
  bottom: 1.5rem;
  cursor: pointer;
  border-radius: 0.2rem;
  transition: all 0.7s linear;
  animation: showEn 1s linear forwards;

  @keyframes showEn {
    from {
      right: -200px;
    }
    to {
      right: 1.5rem;
    }
  }

  .close__entrancer {
    position: absolute;
    font-size: 1rem;
    color: #fff;
    top: 0.18rem;
    right: 0.18rem;
    cursor: pointer;
    transition: all 0.3s ease-in-out;
  }

  .close__entrancer:hover {
    font-size: 1.2rem;
  }

  .chat__entrance__header {
    display: flex;
    justify-content: space-between;
    background: black;
    border-radius: 0.2rem 0.2rem 0 0;
    width: 100%;
    height: 9rem;
    padding: 1rem;
  }

  .image__message {
    display: flex;
    align-items: center;
    gap: 1rem;
  }

  .img {
    width: 3rem;
    height: 3rem;
  }

  .img img {
    width: 100%;
    height: auto;
    border-radius: 0.15rem;
  }

  .chat__entrance__header p {
    flex: 1;
    color: #fff;
    text-align: justify;
    font-size: 1rem;
    line-height: 1.4rem;
    padding: 1rem 0;
  }

  .chat__entrancer__content {
    width: 100%;
    height: 3.5rem;
    border-radius: 0rem 0rem 0.2rem 0.2rem;
  }

  .chat__entrancer__content div {
    width: 100%;
    height: 3rem;
    display: flex;
    align-items: center;
    border-radius: 0 0 0.2rem 0.2rem;
  }

  .chat__entrancer__content input {
    display: block;
    width: 250px;
    padding: 0.9rem 1rem;
    margin: 0;
    font-size: 1rem;
    border: none;
    outline: none;
    border-radius: 0 0 0 0.2rem;
    transition: all 0.5s ease-in-out;
  }

  .chat__entrancer__content input:hover::placeholder {
    color: transparent;
  }

  .chat__entrancer__content button {
    display: flex;
    align-items: center;
    justify-content: center;
    display: block;
    width: 50px;
    height: 100%;
    font-size: 1rem;
    cursor: pointer;
    color: var(--clr-grey-6);
    border: none;
    border-radius: 0 0 0.2rem 0;
    transition: all 0.5s ease-in-out;
  }

  .chat__entrancer__content button:hover {
    color: black;
    font-size: 1.5rem;
  }
`;

export default ChatEntrancer;
